import isArray from 'lodash/isArray';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import { ErrorMessages } from '../validators';
import { isFloat, isInt } from './helpers';
export const getArrayValidator = (params = {}) => {
    const { ignoreRequiredCheck, ignoreMaxLengthCheck, ignoreMinLengthCheck, customErrorMessages } = params;
    return (spec, value) => {
        const errorMessages = Object.assign(Object.assign({}, ErrorMessages), customErrorMessages);
        const valueLength = (value === null || value === void 0 ? void 0 : value.length) || 0;
        if (!ignoreRequiredCheck && spec.required && !isArray(value)) {
            return errorMessages.REQUIRED;
        }
        if (!ignoreMaxLengthCheck &&
            typeof spec.maxLength === 'bigint' &&
            valueLength > spec.maxLength) {
            return errorMessages.maxLengthArr(spec.maxLength);
        }
        if (!ignoreMinLengthCheck &&
            typeof spec.minLength === 'bigint' &&
            valueLength < spec.minLength) {
            return errorMessages.minLengthArr(spec.minLength);
        }
        return false;
    };
};
export const getBooleanValidator = (params = {}) => {
    const { ignoreRequiredCheck, customErrorMessages } = params;
    return (spec, value) => {
        const errorMessages = Object.assign(Object.assign({}, ErrorMessages), customErrorMessages);
        if (!ignoreRequiredCheck && spec.required && !value) {
            return errorMessages.REQUIRED;
        }
        return false;
    };
};
export const getNumberValidator = (params = {}) => {
    const { ignoreRequiredCheck, ignoreSpaceStartCheck, ignoreSpaceEndCheck, ignoreNumberCheck, ignoreMaximumCheck, ignoreMinimumCheck, ignoreIntCheck, ignoreDotEnd, ignoreZeroStart, customErrorMessages, } = params;
    // eslint-disable-next-line complexity
    return (spec, value = '') => {
        const errorMessages = Object.assign(Object.assign({}, ErrorMessages), customErrorMessages);
        const stringValue = String(value);
        if (!ignoreRequiredCheck && spec.required && !stringValue.length) {
            return errorMessages.REQUIRED;
        }
        if (stringValue.length) {
            if (!ignoreSpaceStartCheck && !stringValue[0].trim()) {
                return errorMessages.SPACE_START;
            }
            if (!ignoreSpaceEndCheck && !stringValue[stringValue.length - 1].trim()) {
                return errorMessages.SPACE_END;
            }
            if (!ignoreDotEnd && stringValue[stringValue.length - 1] === '.') {
                return errorMessages.DOT_END;
            }
            if (!ignoreNumberCheck && !isFloat(stringValue)) {
                return errorMessages.NUMBER;
            }
            if (!ignoreZeroStart &&
                ((stringValue.length > 1 && stringValue[0] === '0' && stringValue[1] !== '.') ||
                    (stringValue.length > 2 &&
                        stringValue.substring(0, 2) === '-0' &&
                        stringValue[2] !== '.'))) {
                return errorMessages.ZERO_START;
            }
        }
        if (!ignoreMaximumCheck &&
            isNumber(spec.maximum) &&
            stringValue.length &&
            Number(stringValue) > spec.maximum) {
            return errorMessages.maxNumber(spec.maximum);
        }
        if (!ignoreMinimumCheck &&
            isNumber(spec.minimum) &&
            stringValue.length &&
            spec.minimum > Number(stringValue)) {
            return errorMessages.minNumber(spec.minimum);
        }
        if (isString(spec.format) && stringValue.length) {
            if (!ignoreIntCheck && spec.format === 'int64' && !isInt(stringValue)) {
                return errorMessages.INT;
            }
        }
        return false;
    };
};
export const getObjectValidator = (params = {}) => {
    const { ignoreRequiredCheck, customErrorMessages } = params;
    return (spec, value) => {
        const errorMessages = Object.assign(Object.assign({}, ErrorMessages), customErrorMessages);
        if (!ignoreRequiredCheck && spec.required && !value) {
            return errorMessages.REQUIRED;
        }
        return false;
    };
};
export const getStringValidator = (params = {}) => {
    const { ignoreRequiredCheck, ignoreSpaceStartCheck, ignoreSpaceEndCheck, ignoreMaxLengthCheck, ignoreMinLengthCheck, ignoreRegExpCheck, customErrorMessages, } = params;
    // eslint-disable-next-line complexity
    return (spec, value = '') => {
        const errorMessages = Object.assign(Object.assign({}, ErrorMessages), customErrorMessages);
        const valueLength = value === null || value === void 0 ? void 0 : value.length;
        if (!ignoreRequiredCheck && spec.required && !valueLength) {
            return errorMessages.REQUIRED;
        }
        if (valueLength) {
            if (!ignoreSpaceStartCheck && !value[0].trim()) {
                return errorMessages.SPACE_START;
            }
            if (!ignoreSpaceEndCheck && !value[value.length - 1].trim()) {
                return errorMessages.SPACE_END;
            }
        }
        if (!ignoreMaxLengthCheck &&
            typeof spec.maxLength === 'bigint' &&
            valueLength > spec.maxLength) {
            return errorMessages.maxLength(spec.maxLength);
        }
        if (!ignoreMinLengthCheck &&
            typeof spec.minLength === 'bigint' &&
            valueLength < spec.minLength) {
            return errorMessages.minLength(spec.minLength);
        }
        if (isString(spec.pattern) && spec.pattern.length) {
            const regex = new RegExp(spec.pattern);
            if (!ignoreRegExpCheck && !regex.test(value)) {
                return isString(spec.patternError) && spec.patternError.length
                    ? spec.patternError
                    : errorMessages.INVALID;
            }
        }
        return false;
    };
};
